// Ladeanzeige im Formular (Liste wird geladen).
import { CircleNotch } from '@phosphor-icons/react';

export function FormLaden() {
  return (
    <div role="status" aria-label="Wird geladen" className="flex items-center justify-center" style={{ padding: '40px 0' }}>
      <CircleNotch aria-hidden size={20} weight="bold" color="rgba(255,255,255,0.35)" className="pille-dreh" />
    </div>
  );
}
